import { render, staticRenderFns } from "./arviointityokalut-arvioija-form.vue?vue&type=template&id=14998bf0&scoped=true&"
import script from "./arviointityokalut-arvioija-form.vue?vue&type=script&lang=ts&"
export * from "./arviointityokalut-arvioija-form.vue?vue&type=script&lang=ts&"
import style0 from "./arviointityokalut-arvioija-form.vue?vue&type=style&index=0&id=14998bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14998bf0",
  null
  
)

export default component.exports